module.exports = __webpack_public_path__ + "media/images/provider-logo-ef5d41cdebfef7b0aed024c281b44931.png";